<style>
@import url("https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css");
</style>
<template>
  <ScrollProgressBar :color="'janczaki-yellow'">
    <div class="main-container project janczaki">
      <Menu
        :hamburgerColor="this.activeSectionMenuColor"
        :showChild="showChild"
        :title="sections[activeSectionTitle].title"
        :dot="sections[activeSectionTitle].dot"
        :textColor="sections[activeSectionTitle].textColor"
        :agency="sections[activeSectionTitle].agency"
        :client="sections[activeSectionTitle].client"
        :role="sections[activeSectionTitle].role"
        :url="sections[activeSectionTitle].url"
        :subtitle="sections[activeSectionTitle].subtitle"
        :specificationColor="sections[activeSectionTitle].specificationColor"
        @changeActiveSection="activeSection = $event"
        class="fixed-top janczaki"
      />

      <!-- First section -->
      <section class="section__project intro">
        <div class="main-container__logo white fixed-top">
          <div>
            <router-link to="/" aria-label="intervi logo">
              <svg
                width="109px"
                height="19px"
                viewBox="0 0 109 19"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <polygon
                    id="path-1"
                    points="0 0.385902439 5.90810769 0.385902439 5.90810769 17.9477561 0 17.9477561"
                  />
                  <polygon
                    id="path-3"
                    points="0.000230769231 0.325714286 17.7233077 0.325714286 17.7233077 17.9491286 0.000230769231 17.9491286"
                  />
                  <polygon
                    id="path-5"
                    points="0.0345857143 0.335813953 17.8631571 0.335813953 17.8631571 18.9998674 0.0345857143 18.9998674"
                  />
                  <polygon
                    id="path-7"
                    points="0.35506875 0.03138 5.8695 0.03138 5.8695 5.91358 0.35506875 5.91358"
                  />
                </defs>
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="NEW-NEW-contact" transform="translate(-276.000000, -56.000000)">
                    <g id="Group-21" transform="translate(276.000000, 56.000000)">
                      <g id="Group-3">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M5.90810769,0.859170732 L5.90810769,17.4744878 C5.90810769,17.7357073 5.68564615,17.9477561 5.41056923,17.9477561 L0.497492308,17.9477561 C0.222876923,17.9477561 -4.61538462e-05,17.7357073 -4.61538462e-05,17.4744878 L-4.61538462e-05,0.859170732 C-4.61538462e-05,0.597512195 0.222876923,0.385902439 0.497492308,0.385902439 L5.41056923,0.385902439 C5.68564615,0.385902439 5.90810769,0.597512195 5.90810769,0.859170732"
                          id="Fill-1"
                          fill="#000000"
                          mask="url(#mask-2)"
                        />
                      </g>
                      <g id="Group-6" transform="translate(9.000000, 0.000000)">
                        <mask id="mask-4" fill="white">
                          <use xlink:href="#path-3" />
                        </mask>
                        <g id="Clip-5" />
                        <path
                          d="M17.7233077,7.42298571 L17.7233077,17.4867 C17.7233077,17.7421286 17.5008462,17.9491286 17.2257692,17.9491286 L12.6823846,17.9491286 C12.4073077,17.9491286 12.1848462,17.7421286 12.1848462,17.4867 L12.1848462,8.17727143 C12.1848462,6.05112857 10.7448462,5.05684286 8.97253846,5.05684286 C6.94176923,5.05684286 5.53869231,6.15398571 5.53869231,8.5887 L5.53869231,17.4867 C5.53869231,17.7421286 5.31576923,17.9491286 5.04069231,17.9491286 L0.497769231,17.9491286 C0.222692308,17.9491286 0.000230769231,17.7421286 0.000230769231,17.4867 L0.000230769231,1.26741429 C0.000230769231,1.01198571 0.222692308,0.805414286 0.497769231,0.805414286 L5.04069231,0.805414286 C5.31576923,0.805414286 5.53869231,1.01198571 5.53869231,1.26741429 C5.53869231,1.65227143 6.02146154,1.87512857 6.34130769,1.62955714 C7.39961538,0.8187 8.93192308,0.325414286 10.8186923,0.325414286 C14.5479231,0.325414286 17.7233077,2.79398571 17.7233077,7.42298571"
                          id="Fill-4"
                          fill="#000000"
                          mask="url(#mask-4)"
                        />
                      </g>
                      <path
                        d="M36.9355129,1 L38.7299651,5.47259445 C38.8571375,5.79056622 38.6420179,6.14515833 38.3211967,6.14515833 L36.0428287,6.14515833 C35.7967419,6.14515833 35.5977253,6.36086109 35.5977253,6.62702846 L35.5977253,12.4693131 C35.5977253,13.892594 36.6477234,14.1199081 38.5367291,14.0314834 C38.7885965,14.0194255 39,14.2395941 39,14.5120137 L39,18.4250315 C39,18.6737819 38.8216283,18.8845721 38.5924703,18.906455 C32.4460794,19.487468 30.6429563,17.3643813 30.6429563,12.4693131 L30.6429563,6.62702846 C30.6429563,6.36086109 30.4435269,6.14515833 30.1978529,6.14515833 L28.4455163,6.14515833 C28.1994295,6.14515833 28,5.92990216 28,5.66373478 L28,1"
                        id="Fill-7"
                        fill="#000000"
                      />
                      <g id="Group-11" transform="translate(41.000000, 0.000000)">
                        <mask id="mask-6" fill="white">
                          <use xlink:href="#path-5" />
                        </mask>
                        <g id="Clip-10" />
                        <path
                          d="M12.0975857,7.82963488 C12.4391571,7.82963488 12.6564429,7.46244884 12.5137286,7.1421 C11.8327286,5.61105349 10.4763,5.0375186 9.1203,5.0375186 C7.43001429,5.0375186 6.22744286,5.77675116 5.62272857,7.14254186 C5.48087143,7.4628907 5.69687143,7.82963488 6.03844286,7.82963488 L12.0975857,7.82963488 Z M9.6003,14.2635651 C10.8615857,14.2635651 11.9574429,13.808007 12.6641571,13.1527279 C12.8098714,13.0175186 13.0241571,12.9985186 13.1943,13.0997047 L16.5487286,15.0880767 C16.7908714,15.2312395 16.8615857,15.5674953 16.6850143,15.7910767 C15.0101571,17.9106814 12.5878714,18.9998674 9.53172857,18.9998674 C3.66844286,18.9998674 0.0345857143,14.935193 0.0345857143,9.66777442 C0.0345857143,4.40035581 3.73701429,0.335681395 9.15458571,0.335681395 C14.1598714,0.335681395 17.8631571,4.3301 17.8631571,9.66777442 C17.8631571,10.2682628 17.8185857,10.8448907 17.7290143,11.3985419 C17.6921571,11.6256581 17.4954429,11.7887047 17.2717286,11.7887047 L6.22272857,11.7887047 C5.86187143,11.7887047 5.63558571,12.2000767 5.8263,12.5151233 C6.60201429,13.798286 7.98844286,14.2635651 9.6003,14.2635651 Z"
                          id="Fill-9"
                          fill="#000000"
                          mask="url(#mask-6)"
                        />
                      </g>
                      <path
                        d="M71.5127354,1.43557822 L72.9775077,6.07079646 C73.078264,6.39163042 72.827045,6.70436478 72.4925342,6.69176541 C70.290226,6.60671966 67.3736678,7.65651717 67.3736678,10.8639568 L67.3736678,18.5149243 C67.3736678,18.7831108 67.1573777,19 66.8909333,19 L62.4827345,19 C62.2158423,19 62,18.7831108 62,18.5149243 L62,1.48507575 C62,1.21733913 62.2158423,1 62.4827345,1 L66.8909333,1 C67.1573777,1 67.3736678,1.21733913 67.3736678,1.48507575 L67.3736678,2.01379931 C67.3736678,2.47232638 67.9602932,2.69101545 68.2352459,2.32518374 C68.8711299,1.47832608 69.7416641,1.14579271 71.0434351,1.09719514 C71.2570384,1.08909555 71.4478036,1.23083846 71.5127354,1.43557822"
                        id="Fill-12"
                        fill="#000000"
                      />
                      <path
                        d="M91.9711609,1.65336733 L86.0071913,18.6832158 C85.9403239,18.8735563 85.7686836,19 85.5761738,19 L80.4235562,19 C80.2318982,19 80.0594061,18.8735563 79.9929647,18.6832158 L74.028995,1.65336733 C73.9178334,1.33658317 74.1401566,1 74.4595866,1 L79.1236894,1 C79.3221618,1 79.4980612,1.13454327 79.5598177,1.33388331 L82.5637367,11.0070496 C82.7017304,11.4520774 83.2979996,11.4520774 83.4364192,11.0070496 L86.4403382,1.33388331 C86.5016688,1.13454327 86.6775682,1 86.8764666,1 L91.5401435,1 C91.8599993,1 92.0818966,1.33658317 91.9711609,1.65336733"
                        id="Fill-14"
                        fill="#000000"
                      />
                      <path
                        d="M95.4491667,1 L99.5508333,1 C99.79875,1 100,1.21688916 100,1.48507575 L100,18.5149243 C100,18.7831108 99.79875,19 99.5508333,19 L95.4491667,19 C95.2008333,19 95,18.7831108 95,18.5149243 L95,1.48507575 C95,1.21688916 95.2008333,1 95.4491667,1"
                        id="Fill-16"
                        fill="#000000"
                      />
                      <g id="Group-20" transform="translate(103.000000, 13.000000)">
                        <mask id="mask-8" fill="white">
                          <use xlink:href="#path-7" />
                        </mask>
                        <g id="Clip-19" />
                        <path
                          d="M1.7659125,5.32108 L0.9105375,4.40868 C0.1699125,3.61868 0.1699125,2.32628 0.9105375,1.53588 L1.7659125,0.62388 C2.5065375,-0.16612 3.7181625,-0.16612 4.4587875,0.62388 L5.3141625,1.53588 C6.0547875,2.32628 6.0547875,3.61868 5.3141625,4.40868 L4.4587875,5.32108 C3.7181625,6.11108 2.5065375,6.11108 1.7659125,5.32108"
                          id="Fill-18"
                          fill="#000000"
                          mask="url(#mask-8)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </router-link>
          </div>
        </div>
        <div class="section-box">
          <ComponentJanczaki />
          <FloatingSocials :hoverColor="projects[5].dot" />
          <FloatingText />
          <div class="row col-sm-12">
            <div class="col-xs-12 col-md-6 title__box">
              <h2
                v-bind:style="{ color: projects[5].textColor }"
                style="transform: matrix(1, 0, 0, 1, 0, 0);"
              >
                <svg
                  class="logo-intro janczaki-logo"
                  data-aos="fade-up"
                  width="67px"
                  height="69px"
                  viewBox="0 0 67 69"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Janczaki" transform="translate(-281.000000, -286.000000)">
                      <g id="Group-24" transform="translate(281.000000, 286.000000)">
                        <path
                          d="M16.0675083,23.0927778 C16.5283055,22.0414388 16.8147471,20.8856189 16.9206059,19.6187881 C17.0264647,18.3519572 17.0264647,17.0851263 16.9206059,15.8052354 C16.845882,14.8910275 16.7213422,13.8527486 16.5469865,12.7034588 C16.3726308,11.5541689 16.1484591,10.3852889 15.8744716,9.19681872 C15.606711,8.00834853 15.2891345,6.85252862 14.9217421,5.72935899 C14.5543497,4.60618936 14.1495954,3.6070908 13.7074791,2.73859335 C13.2653628,1.8700959 12.7858846,1.18444003 12.2690444,0.681625716 C11.7522043,0.178811405 11.1980022,-0.0497405544 10.6064381,0.00902994947 C9.97751216,0.0678004533 9.47312598,0.329002693 9.08705261,0.799166723 C8.70097924,1.26933075 8.5390775,1.89621613 8.6013474,2.67329279 C8.63248235,3.09121637 8.81929204,3.67239136 9.1555495,4.42987785 C9.49180695,5.18083429 9.87165333,6.11463229 10.3013156,7.23127186 C10.7309779,8.34138138 11.1419593,9.64739258 11.5404866,11.1427754 C11.939014,12.6381582 12.2130015,14.3490329 12.3686763,16.2688693 C12.4122652,16.7847438 12.4434002,17.3659187 12.4620811,18.0123943 C12.4807621,18.6588698 12.4309462,19.259635 12.3126334,19.8277499 C12.1943206,20.3958647 11.9763759,20.8856189 11.6587994,21.2970124 C11.3412229,21.708406 10.8804257,21.943488 10.2701807,21.9957284 C9.62880073,22.0544989 9.03723669,21.9891984 8.51416954,21.8128869 C7.9848754,21.6365754 7.50539718,21.3688431 7.08196187,21.0227501 C6.65229956,20.6766571 6.29113415,20.2717937 5.98601165,19.8016296 C5.68088914,19.3314656 5.43180955,18.8286513 5.23877286,18.2866566 C5.0893251,17.8817932 4.94610434,17.4442794 4.80911056,16.9806454 C4.67211678,16.5170115 4.49776107,16.0794977 4.2922704,15.6811643 C4.08677973,15.2828309 3.81901917,14.9628581 3.4889887,14.7212461 C3.15895824,14.479634 2.74174992,14.3816832 2.23113675,14.4273936 C1.88242532,14.4600438 1.57107582,14.5645247 1.29708827,14.7473663 C1.02310071,14.9302079 0.786475096,15.1522298 0.59343841,15.4264921 C0.400401724,15.6942244 0.250953966,15.994607 0.145095138,16.3276398 C0.0392363104,16.6606727 -0.0105796086,16.9806454 0.00187437113,17.2940881 C0.0267823307,17.6401811 0.0952792194,18.0058642 0.201138047,18.3846075 C0.306996875,18.7698808 0.412855703,19.0963836 0.518714531,19.3641159 C0.911014894,20.4807555 1.42162806,21.5255644 2.06923501,22.5050728 C2.71061497,23.4845812 3.46408075,24.3204284 4.32963234,25.0060842 C5.18895694,25.6982702 6.14168639,26.2206747 7.18782069,26.5798277 C8.227728,26.9389808 9.3361322,27.0695819 10.5068063,26.965101 C11.9763759,26.8344999 13.153277,26.4165763 14.0437366,25.7243904 C14.9279691,25.0191444 15.606711,24.1441169 16.0675083,23.0927778"
                          id="Fill-1"
                          fill="#FFFFFF"
                        />
                        <path
                          d="M24.7200767,12.8402049 C24.8204028,12.298885 24.9809247,11.8097406 25.2150191,11.3727716 C25.4424251,10.9292807 25.7300268,10.5705747 26.0644473,10.2901319 C26.4055563,10.0096891 26.7867958,9.84664099 27.2081657,9.78794366 C27.6161588,9.73576826 28.0375287,9.77489981 28.4722755,9.90533832 C28.9070222,10.0357768 29.375211,10.374917 29.8567766,10.9292807 C30.0106101,11.9793107 30.204574,13.0619503 30.43198,14.1837216 C30.659386,15.3054928 30.9336109,16.3685667 31.2412778,17.3794651 C30.8934804,17.5816448 30.5189293,17.7642587 30.1176247,17.9273069 C29.71632,18.090355 29.261508,18.2077497 28.7531887,18.266447 C28.1712969,18.3381882 27.6429124,18.2729689 27.1680352,18.0707893 C26.693158,17.8686096 26.2851649,17.5816448 25.9373675,17.2098951 C25.5962586,16.8381453 25.3153453,16.4142201 25.0946277,15.9315976 C24.8805985,15.4489751 24.7401419,14.9663526 24.6732578,14.4837301 C24.6130621,13.9293665 24.6197505,13.3750028 24.7200767,12.8402049 M20.9611894,18.2860128 C21.4160014,19.2773455 22.0246469,20.1447616 22.7804373,20.8882611 C23.5429162,21.6317607 24.4525402,22.1991682 25.5159976,22.5904837 C26.579455,22.9817993 27.7833691,23.092672 29.1210514,22.9231019 C29.7698273,22.8383169 30.4052264,22.6948345 31.0138718,22.4861329 C31.6225172,22.2774313 32.2177858,22.0230762 32.806366,21.7230676 C32.9334459,21.8469842 33.0939677,21.951335 33.3013085,22.0295981 C33.4685188,22.0948174 33.6959248,22.1535147 33.9701496,22.1926463 C34.2443745,22.2382998 34.5854835,22.2317778 34.9934766,22.1796024 C35.3078319,22.1209051 35.5954336,22.0035104 35.8629701,21.8208965 C36.1238181,21.6382826 36.3512241,21.423059 36.5318112,21.162182 C36.7123983,20.9078269 36.8394781,20.6273841 36.9197391,20.3338975 C37,20.0404108 37.0200652,19.7469241 36.9799348,19.4534375 C36.9331159,19.1142974 36.8261013,18.7555914 36.6522026,18.3838417 C36.4783039,18.0120919 36.3244704,17.6664299 36.1907022,17.3338117 C35.9231658,16.6816191 35.7091366,16.0881239 35.5419263,15.5533259 C35.374716,15.0120061 35.2342594,14.496774 35.1205564,13.9880638 C35.0068534,13.4858755 34.9132156,12.9836872 34.8396431,12.4880209 C34.7667394,11.9923545 34.6924981,11.4640786 34.6189255,10.9097149 C34.4918457,9.96403565 34.4249616,9.10966339 34.4048964,8.34659809 C34.3848311,7.59005471 34.3313238,6.84655519 34.2309977,6.12262144 C34.1440483,5.45086309 33.8765119,4.91606519 33.4417651,4.5117058 C33.00033,4.11386833 32.5053875,3.94429827 31.9368726,4.01603945 C31.5288795,4.06821485 31.2011473,4.17256566 30.9402993,4.32256996 C30.6794512,4.47909617 30.4654221,4.63562239 30.2915234,4.79867053 C30.1042478,4.9943283 29.9504144,5.20955185 29.8367114,5.43129732 C28.8802686,5.09867911 27.8903837,4.9943283 26.8670567,5.12476681 C25.7567804,5.26172725 24.7468303,5.65304279 23.8372064,6.29219151 C22.9275824,6.93134022 22.1717919,7.72049323 21.5698349,8.65965052 C20.9678779,9.59880782 20.5331311,10.6423159 20.2589062,11.7836529 C19.9913698,12.9249899 19.9311741,14.0728488 20.0783191,15.2272297 C20.2120874,16.2837816 20.5063775,17.2946801 20.9611894,18.2860128"
                          id="Fill-3"
                          fill="#FFFFFF"
                        />
                        <path
                          d="M38.9751549,21.162881 C39.0820658,21.5188481 39.3021763,21.8100939 39.6291976,22.0430905 C39.956219,22.2760872 40.2895292,22.4055297 40.6228395,22.4249461 C40.9561497,22.4508346 41.2643045,22.3990576 41.5535926,22.2760872 C41.8365918,22.1531167 42.0881467,21.9848414 42.2956795,21.7777333 C42.5032123,21.5706251 42.6730119,21.3311564 42.7987893,21.0657991 C42.9245667,20.8004418 43.0000332,20.5286124 43.0188998,20.256783 C43.0314776,20.1014519 43.0188998,19.9267044 42.9811666,19.7260685 C42.9434334,19.5254325 42.8994113,19.3247965 42.8491003,19.1241605 C42.7987893,18.9235245 42.7359006,18.7293606 42.6793007,18.5416689 C42.616412,18.3539772 42.5723899,18.192174 42.5528944,18.0497871 C42.3774349,17.2084104 42.270524,16.3152566 42.2265019,15.3703259 C42.1824798,14.4253951 42.1950576,13.5451856 42.2516574,12.7167531 C42.2893906,12.1666222 42.4151681,11.6812125 42.6289897,11.2605242 C42.8428114,10.8333637 43.106944,10.4838687 43.4213877,10.2055672 C43.7358313,9.92726565 44.0691415,9.72015753 44.4213184,9.58424283 C44.7734952,9.44832813 45.1068054,9.39007897 45.4275379,9.41596748 C45.9117811,9.45480025 46.3142689,9.64896411 46.6406614,9.99845906 C46.9683116,10.3544261 47.2261554,10.801003 47.4148216,11.351134 C47.6034878,11.9012649 47.7292652,12.5031729 47.7921539,13.16333 C47.8550426,13.8234871 47.8613315,14.4771721 47.8173094,15.1308571 C47.7544207,16.0563715 47.6600876,16.8006663 47.5468879,17.3637415 C47.4336882,17.9268167 47.3141996,18.39281 47.1947111,18.7746655 C47.0752225,19.1565211 46.9683116,19.4930718 46.8739786,19.7843176 C46.7796455,20.0820355 46.7167568,20.4315305 46.6853124,20.8457467 C46.6406614,21.4800153 46.7796455,21.9848414 47.1066668,22.366697 C47.4336882,22.7420804 47.8801981,22.9556607 48.4461966,22.9944934 C48.8989955,23.0268541 49.2889055,22.9168279 49.6278758,22.6579428 C49.9681037,22.3990576 50.256763,22.0495627 50.5089468,21.6094579 C50.7605017,21.1693532 50.9680344,20.6709992 51.1315451,20.1014519 C51.2950558,19.5383767 51.4396999,18.9623573 51.5528996,18.3863378 C51.6660993,17.8103184 51.7541435,17.2537153 51.8107433,16.7230008 C51.8673432,16.1922862 51.9050764,15.7392372 51.9302319,15.3638537 C52.0308539,13.920569 52.024565,12.5873105 51.8987875,11.3640782 C51.7730101,10.1408459 51.5025886,9.07294466 51.0686564,8.16037452 C50.6410131,7.24780438 50.0247036,6.51645384 49.2260168,5.9663229 C48.42733,5.41619196 47.4022438,5.09258553 46.1507582,4.9955036 C45.6162041,4.95667082 45.0879388,5.00197573 44.5596735,5.13789043 C44.0314083,5.267333 43.5408762,5.45502473 43.0880774,5.70096562 C43.0503442,5.29969364 42.9057001,4.93078231 42.6541452,4.58128736 C42.4025903,4.23179241 42.0189691,4.04410068 41.5032816,4.00526791 C41.0693494,3.97290727 40.647995,4.08940558 40.2329294,4.36123499 C39.8178638,4.63306439 39.5285757,4.98903147 39.365065,5.42266409 C39.0128882,6.38053913 38.7298889,7.40313546 38.5160672,8.49045308 C38.3022456,9.5777707 38.1576015,10.697449 38.0758462,11.8494879 C37.9626465,13.4610479 37.9752242,15.0790801 38.1198683,16.6906401 C38.2456457,18.2892559 38.5349339,19.7843176 38.9751549,21.162881"
                          id="Fill-5"
                          fill="#FFFFFF"
                        />
                        <path
                          d="M19.5519126,42.2950091 C20.4763206,42.7624417 21.4772313,43 22.5673953,43 C23.3132969,43 24.0655738,42.9033119 24.8306011,42.7176194 C25.5956284,42.531927 26.284153,42.2693963 26.9025501,41.9364306 C27.5209472,41.6034648 28.0245902,41.2071075 28.4134791,40.7524812 C28.8023679,40.2908114 29,39.7920031 29,39.2470919 C29,38.60037 28.8151184,38.0689054 28.43898,37.6526982 C28.0628415,37.2371314 27.6102004,37.0258262 27.068306,37.0258262 C26.7304189,37.0258262 26.4307832,37.1026644 26.1630237,37.2492974 C25.9016393,37.4029739 25.6147541,37.5630536 25.3087432,37.73658 C25.0027322,37.9088257 24.6584699,38.0689054 24.2759563,38.2097755 C23.8934426,38.351286 23.4216758,38.4210807 22.867031,38.4210807 C22.3570128,38.4210807 21.8916211,38.3122265 21.4708561,38.1009213 C21.0500911,37.8896162 20.6803279,37.6085162 20.3679417,37.2492974 C20.0555556,36.8913593 19.8069217,36.4745118 19.6284153,35.9878695 C19.4499089,35.5076305 19.3606557,34.9896126 19.3606557,34.4447014 C19.3606557,33.7979794 19.4052823,33.1839138 19.5009107,32.6005834 C19.5965392,32.0114902 19.7622951,31.4992352 19.9981785,31.0446089 C20.2340619,30.5963858 20.5591985,30.2378073 20.9672131,29.9752766 C21.3752277,29.7133862 21.8916211,29.5789193 22.5163934,29.5789193 C22.924408,29.5789193 23.3324226,29.7005798 23.7340619,29.9496638 C24.1420765,30.1993881 24.5373406,30.5899826 24.9262295,31.1342535 C25.1111111,31.3583651 25.3342441,31.5184447 25.6020036,31.6215361 C25.863388,31.7233467 26.1247723,31.7745722 26.3797814,31.7745722 C26.6666667,31.7745722 26.9408015,31.7041372 27.208561,31.5568639 C27.4699454,31.4095906 27.6994536,31.2303013 27.8970856,31.0068301 C28.0947177,30.7884814 28.2477231,30.5323539 28.3688525,30.2506136 C28.4899818,29.9688734 28.5473588,29.6935363 28.5473588,29.4188396 C28.5473588,28.7529081 28.3624772,28.1567714 27.9990893,27.619544 C27.6357013,27.0810359 27.1703097,26.6206467 26.6156648,26.229412 C26.0546448,25.8388175 25.4362477,25.5385081 24.7477231,25.3201594 C24.0591985,25.1088542 23.3961749,25 22.7522769,25 C21.4326047,25 20.2850638,25.2753371 19.3224044,25.8330547 C18.3533698,26.3830885 17.5500911,27.1066486 16.9061931,28.0030949 C16.2622951,28.9001814 15.784153,29.9112447 15.4717668,31.0446089 C15.1593807,32.177973 15,33.3241436 15,34.4767173 C15,35.5972751 15.1912568,36.6736509 15.5737705,37.6917577 C15.9562842,38.7092241 16.4854281,39.6127139 17.1612022,40.3996656 C17.8242259,41.200064 18.6275046,41.8282167 19.5519126,42.2950091"
                          id="Fill-7"
                          fill="#FFFFFF"
                        />
                        <path
                          d="M32.1152035,27.2565947 C31.6648629,27.3980922 31.2842934,27.5846117 30.9608093,27.8225849 C30.6436681,28.060558 30.3962979,28.3499848 30.2250416,28.7037287 C30.0537853,29.0510408 29.9840142,29.507692 30.0030427,30.0736822 C30.0093855,30.208748 30.0474425,30.3824041 30.1235564,30.581787 C30.1996703,30.7811699 30.320184,30.9741211 30.4787546,31.1413455 C30.6373252,31.3150015 30.8529813,31.4564991 31.11938,31.5722698 C31.3857786,31.6880405 31.7219484,31.7394942 32.1278892,31.720199 C32.495773,31.7009039 32.8826854,31.655882 33.2759405,31.5787015 C33.6691957,31.501521 34.069428,31.4179088 34.4683917,31.3214332 C34.8679897,31.2249576 35.2802733,31.1413455 35.6988998,31.064165 C36.1175262,30.9869845 36.5424955,30.9355308 36.9864933,30.9162357 C35.8194134,32.4212551 34.6967334,33.9584329 33.6247959,35.5213376 C32.5528585,37.0842423 31.5697205,38.7114641 30.681725,40.4152232 C30.4343548,40.8918126 30.320184,41.3542523 30.3392125,41.8179784 C30.3645838,42.3839686 30.5041259,42.8148929 30.7641817,43.1229717 C31.0242376,43.425905 31.3540645,43.6510148 31.7536625,43.7860806 C32.1532605,43.9211464 32.5972582,43.9918952 33.0793129,43.9983269 C33.5613677,44.0047586 34.0307367,43.9918952 34.4810773,43.9726001 C36.1682688,43.8954196 37.760318,43.6188562 39.2699104,43.1429099 C40.780137,42.6663205 42.2827523,42.0366564 43.7860019,41.2519882 C44.2179483,41.0461736 44.5281125,40.7110817 44.7310829,40.2615054 C44.9277104,39.8112859 45.01651,39.3224762 44.9974815,38.8143714 C44.9403961,38.2033593 44.6866831,37.6888228 44.2490282,37.2836252 C43.8113732,36.8777846 43.2532046,36.6854765 42.5814994,36.7169919 C42.1939528,36.7369302 41.8450974,36.8334058 41.5279561,37.0199253 C40.8048741,37.4830081 40.0627635,37.8753423 39.3022588,38.209791 C38.5404855,38.5442397 37.7476323,38.7629178 36.9236993,38.8658251 C37.8237462,37.3865326 38.7688272,35.9651254 39.7646507,34.5951719 C40.7604743,33.2252184 41.8514402,31.8616966 43.0438914,30.5110382 C43.3800611,30.1379992 43.6591454,29.771392 43.8684586,29.4240798 C44.084749,29.0703359 44.1792571,28.6587067 44.1538858,28.1763287 C44.1285145,27.5974751 43.9699438,27.1536874 43.6781739,26.8513972 C43.3864039,26.5491069 43.0375485,26.3304289 42.6252649,26.2017948 C42.2129813,26.0731607 41.7753263,26.0088436 41.2996144,26.0024119 C40.8239025,25.9959802 40.3868819,26.0024119 39.9872839,26.021707 C38.8265469,26.0731607 37.7286038,26.1632046 36.707409,26.2982704 C35.6862141,26.4269045 34.6459908,26.6198557 33.5930818,26.8706923 C33.0539416,26.986463 32.5655441,27.1215288 32.1152035,27.2565947"
                          id="Fill-9"
                          fill="#FFFFFF"
                        />
                        <path
                          d="M56.2895427,34.3870683 C56.2225636,35.4939839 56.2099635,36.5566228 56.2563847,37.5813104 C55.8717519,37.6888394 55.4605928,37.7710674 55.0355072,37.8279945 C54.611748,37.8849215 54.147536,37.8849215 53.6369028,37.8279945 C53.0599536,37.7584169 52.5692152,37.5749852 52.1646876,37.271374 C51.76016,36.9677629 51.44118,36.6008995 51.2031056,36.1771089 C50.964368,35.7469932 50.8045464,35.2852512 50.7189988,34.7792327 C50.632788,34.2732142 50.6195248,33.7924965 50.6858408,33.3244294 C50.7587884,32.7741342 50.9113152,32.2554652 51.1434212,31.7747476 C51.3755272,31.2940299 51.660686,30.8702394 51.992266,30.5097012 C52.323846,30.149163 52.6879208,29.877178 53.08648,29.7000715 C53.484376,29.5166398 53.8955352,29.4533875 54.313326,29.5039893 C54.7178536,29.5545912 55.109118,29.6874211 55.5003824,29.9151294 C55.8850151,30.1428378 56.2431215,30.5666283 56.5680699,31.2054767 C56.4487011,32.2175138 56.3558587,33.2801527 56.2895427,34.3870683 M60.3142607,25.2091569 C59.9103963,25.158555 59.5648899,25.1775307 59.2803943,25.266084 C58.9952355,25.348312 58.7432347,25.4495157 58.5376551,25.5570447 C58.3055491,25.6961998 58.1066011,25.8606558 57.9408111,26.0440875 C57.1045664,25.5064428 56.1834371,25.1712055 55.1688024,25.0510261 C54.0672936,24.9181962 53.0002692,25.0447009 51.959108,25.43054 C50.9245784,25.8163792 49.9961544,26.3793248 49.1804676,27.1193769 C48.3647808,27.8594291 47.681726,28.732311 47.1306401,29.7443481 C46.5802173,30.7563852 46.2294057,31.8190242 46.0828473,32.9385902 C45.9508785,33.9379769 45.9774049,34.9626644 46.1564581,36 C46.3421429,37.0373405 46.7002493,37.9987757 47.2433773,38.8779829 C47.7878316,39.7571902 48.5173076,40.5035675 49.4391,41.1234402 C50.3608924,41.743313 51.4882644,42.1291521 52.8145844,42.2936081 C53.4644812,42.3695109 54.1011148,42.3821614 54.74438,42.3315595 C55.3810136,42.2803252 56.0176471,42.1860792 56.6609123,42.0405989 C56.74646,42.1860792 56.8797551,42.3189091 57.0588083,42.4454137 C57.2047035,42.5466174 57.4036515,42.6541464 57.6556523,42.7616753 C57.90699,42.8692042 58.2326015,42.945107 58.6371291,42.9957089 C58.9554459,43.0146846 59.2598363,42.9704079 59.5589215,42.8692042 C59.8573435,42.7616753 60.1292391,42.6098697 60.3673135,42.4074623 C60.6067143,42.2113801 60.7990307,41.9773465 60.9515575,41.718012 C61.1040843,41.4586775 61.1962635,41.1866926 61.2300847,40.9020571 C61.2765059,40.5731451 61.2566111,40.2126069 61.1836635,39.8204425 C61.1107159,39.4339708 61.0510315,39.0677399 61.0112419,38.7261774 C60.9250311,38.0557028 60.8646835,37.4421553 60.8381571,36.8981854 C60.8122939,36.3542154 60.8122939,35.8292212 60.8321887,35.3295279 C60.8520835,34.8298346 60.8912099,34.3364665 60.9449259,33.8557488 C60.9979787,33.368706 61.0642947,32.8563622 61.1306107,32.3250427 C61.2493163,31.4078841 61.4025063,30.585604 61.5749279,29.8708528 C61.7466863,29.1561016 61.8859499,28.4413504 61.9728239,27.7392496 C62.0590347,27.0877508 61.9396659,26.5184799 61.6213491,26.0440875 C61.3162955,25.5507194 60.8719783,25.2787345 60.3142607,25.2091569"
                          id="Fill-11"
                          fill="#FFFFFF"
                        />
                        <g id="Group-15" transform="translate(37.000000, 45.000000)">
                          <mask id="mask-2" fill="white">
                            <use xlink:href="#path-1" />
                          </mask>
                          <g id="Clip-14" />
                          <path
                            d="M12.5637909,16.8798 C12.2710636,16.1464667 11.9083364,15.4598 11.4883364,14.8198 C11.0619727,14.1798 10.5847,13.6331333 10.0437909,13.1731333 C10.3492455,12.9064667 10.6992455,12.5538 11.1001545,12.1064667 C11.4947,11.6671333 11.8701545,11.1798 12.2137909,10.6598 C12.5574273,10.1404667 12.8501545,9.59313333 13.0919727,9.02713333 C13.3337909,8.4598 13.4483364,7.92646667 13.4483364,7.43313333 C13.4483364,6.8998 13.2701545,6.42646667 12.9137909,6.01313333 C12.5574273,5.5998 12.1247,5.38713333 11.6219727,5.38713333 C11.1510636,5.38713333 10.7565182,5.50046667 10.4574273,5.72046667 C10.1519727,5.9398 9.8847,6.22713333 9.65560909,6.57313333 C9.42651818,6.92046667 9.20379091,7.29313333 8.99379091,7.68646667 C8.78379091,8.08713333 8.52288182,8.4598 8.21742727,8.81313333 C7.7777,9.32646667 7.2947,9.8198 6.77288182,10.2864667 C6.25106364,10.7598 5.63379091,11.1331333 4.92106364,11.4204667 C4.92106364,10.2864667 4.9847,9.20646667 5.11197273,8.1938 C5.23924545,7.17313333 5.37288182,6.2598 5.51924545,5.4398 C5.66560909,4.62646667 5.79924545,3.92646667 5.92651818,3.3398 C6.05379091,2.7538 6.11742727,2.31313333 6.11742727,2.01313333 C6.11742727,1.6798 6.06015455,1.38713333 5.95197273,1.14646667 C5.84379091,0.906466667 5.70379091,0.706466667 5.53197273,0.546466667 C5.36015455,0.387133333 5.17560909,0.273133333 4.95924545,0.1998 C4.74924545,0.126466667 4.54560909,0.0931333333 4.36106364,0.0931333333 C3.95379091,0.0931333333 3.61015455,0.1798 3.33015455,0.360466667 C3.05015455,0.5398 2.80833636,0.780466667 2.6047,1.09313333 C2.40106364,1.40646667 2.22924545,1.7598 2.09560909,2.17313333 C1.96197273,2.5798 1.8347,3.00646667 1.71379091,3.44713333 C1.15379091,5.73313333 0.797427273,7.9738 0.651063636,10.1598 C0.498336364,12.3464667 0.421972727,14.5538 0.421972727,16.7664667 C0.421972727,17.3871333 0.447427273,18.0538 0.498336364,18.7598 C0.549245455,19.4664667 0.657427273,20.1264667 0.829245455,20.7271333 C1.00106364,21.3264667 1.24924545,21.8338 1.58015455,22.2271333 C1.91106364,22.6264667 2.34379091,22.8264667 2.8847,22.8264667 C3.24106364,22.8264667 3.55924545,22.7538 3.84560909,22.5998 C4.13197273,22.4471333 4.38015455,22.2538 4.59588182,22.0131333 C4.80651818,21.7731333 4.97197273,21.4931333 5.09288182,21.1731333 C5.21379091,20.8531333 5.27106364,20.5271333 5.27106364,20.1938 C5.27106364,19.8198 5.25197273,19.4598 5.20742727,19.0998 C5.16288182,18.7464667 5.11833636,18.3731333 5.06742727,17.9864667 C5.01651818,17.5998 4.97197273,17.1731333 4.92742727,16.7271333 C4.88288182,16.2731333 4.86379091,15.7664667 4.86379091,15.1998 C5.65924545,15.4131333 6.32042727,15.7731333 6.84288182,16.2864667 C7.3647,16.7998 7.7777,17.3731333 8.08379091,18.0131333 C8.38860909,18.6531333 8.60560909,19.2998 8.73224545,19.9531333 C8.86015455,20.6064667 8.92379091,21.1731333 8.92379091,21.6531333 C8.92379091,21.9398 8.9747,22.2131333 9.07651818,22.4931333 C9.17833636,22.7664667 9.31833636,23.0131333 9.49651818,23.2398 C9.6747,23.4598 9.89106364,23.6404667 10.1583364,23.7864667 C10.4256091,23.9331333 10.7119727,24.0004667 11.0365182,24.0004667 C11.3610636,24.0004667 11.6601545,23.9531333 11.9528818,23.8531333 C12.2392455,23.7538 12.5001545,23.6064667 12.7292455,23.3998 C12.9583364,23.1938 13.1365182,22.9471333 13.2765182,22.6531333 C13.4101545,22.3604667 13.4801545,22.0198 13.4801545,21.6264667 C13.4801545,20.8264667 13.4037909,20.0198 13.2510636,19.2064667 C13.0983364,18.3938 12.8565182,17.6138 12.5637909,16.8798"
                            id="Fill-13"
                            fill="#FFFFFF"
                          />
                        </g>
                        <path
                          d="M57.7398141,52.9285288 C57.6264506,52.6917934 57.4699011,52.4879379 57.2659668,52.3103864 C57.0620325,52.1328349 56.8041156,52.0341951 56.486218,52.0078912 C56.1983108,51.9815872 55.9343958,52.0210431 55.6884751,52.1262589 C55.4425543,52.230817 55.2272237,52.3629943 55.0466819,52.5333122 C54.8667399,52.7049454 54.7107901,52.8884153 54.5848307,53.0863524 C54.4588713,53.2836319 54.3689003,53.4677594 54.3035213,53.6387349 C53.985024,54.5264926 53.7391032,55.51289 53.5651593,56.5979272 C53.3912153,57.6895404 53.2592578,58.8666413 53.1692868,60.142382 C53.09731,61.1156274 53.0493255,62.062569 53.0133371,62.9832066 C52.9779485,63.9031866 53.0133371,64.7251844 53.1153042,65.4492001 C53.2172714,66.1784766 53.4038112,66.7709727 53.6851206,67.2312915 C53.9670298,67.6916103 54.3808964,67.9480736 54.9387167,67.9941055 C55.1906355,68.0131758 55.4545504,67.9868719 55.7244635,67.9020417 C55.9943765,67.8224723 56.2402973,67.6843767 56.4622257,67.4936732 C56.6841542,67.3036273 56.8700943,67.0530823 57.0320421,66.7512447 C57.1879919,66.4487495 57.283961,66.0804945 57.3139513,65.6464796 C57.3559378,65.0875211 57.3619358,64.6140503 57.3439416,64.2260673 C57.3265472,63.8380843 57.302555,63.4566773 57.2779629,63.0884223 C57.2539706,62.7201672 57.2359764,62.3190323 57.2179822,61.8850174 C57.199988,61.4510026 57.2119842,60.9249239 57.2599687,60.2936296 C57.289959,59.8398868 57.3439416,59.346688 57.4159184,58.8067998 C57.4878953,58.2682269 57.5598721,57.7355722 57.6378469,57.1963416 C57.7158218,56.6571111 57.7877986,56.1501028 57.8537774,55.6641376 C57.9197561,55.1775149 57.9677406,54.763228 57.9917329,54.4147009 C58.0097271,54.1911175 57.997731,53.9412301 57.9617426,53.6781908 C57.926354,53.4151515 57.8537774,53.1652642 57.7398141,52.9285288"
                          id="Fill-16"
                          fill="#FFFFFF"
                        />
                        <path
                          d="M56.9663484,46.0083915 C56.5934556,45.9775446 56.2327783,46.0325851 55.8856023,46.1596017 C55.5384263,46.2866184 55.2368975,46.4680707 54.9668717,46.7094022 C54.6968459,46.9458951 54.4782536,47.2301704 54.3040227,47.5567845 C54.1310776,47.8833987 54.0282107,48.2281581 54.0024939,48.5965063 C53.9767772,49.2866299 54.1503652,49.8491321 54.5039704,50.2785692 C54.8633618,50.7080064 55.359052,50.9432895 55.9884693,50.9916768 C56.3620049,51.0225237 56.7284685,50.9674832 57.0820737,50.8289746 C57.435036,50.6959096 57.750709,50.496312 58.0207348,50.2422788 C58.2907606,49.9876407 58.5087099,49.6918734 58.6829409,49.347114 C58.8558859,49.0017498 58.9593958,48.63945 58.9908988,48.2584002 C59.0423323,47.634809 58.8758164,47.1146457 58.4900653,46.6979103 C58.1043142,46.2866184 57.5957656,46.0561739 56.9663484,46.0083915"
                          id="Fill-18"
                          fill="#FFFFFF"
                        />
                        <path
                          d="M32.8849344,47.0065418 C31.6772301,47.0881143 30.4695258,47.1743151 29.2555314,47.2558876 C27.1294686,47.4005198 25.0034058,47.5451519 22.8710528,47.6897841 C21.6193177,47.7759848 20.3675825,47.8627641 19.1158473,47.9437581 C16.3041607,48.1346725 16.2852903,52.1843726 19.1158473,51.9934582 C21.0972371,51.8609752 23.078627,51.7215498 25.0600169,51.5884882 C27.6641293,51.4091443 30.2745319,51.2361643 32.8786443,51.0562419 C35.696621,50.8653275 35.7154914,46.8156274 32.8849344,47.0065418"
                          id="Fill-20"
                          fill="#FFFFFF"
                        />
                        <path
                          d="M64.8339061,16.1384799 C62.2801615,16.0943536 59.7251334,16.0447116 57.1713888,16.0005854 C54.2762037,15.9454276 54.2762037,19.8064731 57.1713888,19.8616309 C59.7251334,19.9057571 62.2801615,19.9553992 64.8339061,19.9995254 C67.7220313,20.0491674 67.7220313,16.1881219 64.8339061,16.1384799"
                          id="Fill-22"
                          fill="#FFFFFF"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
                Brand heroes -
                <br />win hearts,
                <br />increase sales.
                <span v-bind:style="{ color: projects[5].dot }">.</span>
              </h2>
              <div class="scroll-down">
                <span style="transform: matrix(1, 0, 0, 1, 0, 0);">
                  <span class="mouse">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M256,140.15c-9.364,0-16.954,7.59-16.954,16.954v59.338c0,9.364,7.59,16.954,16.954,16.954
                              c9.364,0,16.954-7.59,16.954-16.954v-59.338C272.954,147.74,265.364,140.15,256,140.15z"
                          />
                        </g>
                      </g>
                    </svg>
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M256,0C156.595,0,75.726,82.14,75.726,183.099v145.807C75.726,429.865,156.595,512,256,512
                              c99.399,0,180.274-81.886,180.274-182.534V183.099C436.274,82.14,355.399,0,256,0z M402.366,329.466
                              c0,81.954-65.656,148.627-146.366,148.627c-80.705,0-146.366-66.927-146.366-149.192V183.099
                              c0-82.265,65.661-149.192,146.366-149.192c80.711,0,146.366,66.927,146.366,149.192V329.466z"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span>Scroll down</span>
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-md-6"></div>
          </div>
        </div>
      </section>

      <!-- Description section -->
      <section class="section__project description">
        <div class="section-box title__box">
          <FloatingSocials :hoverColor="projects[5].dot" />
          <FloatingText />

          <div class="text-container">
            <h2 data-aos="fade-up">
              It’s time to stand out.
              <br />Modern branding and brand strategy.
            </h2>

            <div class="specification" data-aos="fade-up">
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">Agency</span>
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">
                    {{
                    projects[5].agency
                    }}
                  </span>
                </li>
              </ul>
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">Client</span>
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">
                    {{
                    projects[5].client
                    }}
                  </span>
                </li>
              </ul>
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">Solutions</span>
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">
                    {{
                    projects[5].role
                    }}
                  </span>
                </li>
              </ul>
            </div>

            <p class="text-standard" data-aos="fade-up">
              The goal of the new strategy is to reach a younger audience that
              responds to the bywords 'modern', 'original' and 'contemporary'.
              Grits are associated with traditional cooking, but by introducing
              fresh, bright colors and brand heroes, we highlight that the brand
              serves the needs of both traditional and modern consumers.
            </p>
            <div class="row lists" data-aos="fade-up">
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Website</span>
                <li v-for="(item, index) in projects[5].Webpage" :key="index">{{ item }}</li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Content marketing</span>
                <li v-for="(item, index) in projects[5].ContentMarketing" :key="index">{{ item }}</li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Visual ID</span>
                <li
                  v-for="(item, index) in projects[5].VisualIdentification"
                  :key="index"
                >{{ item }}</li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Brand strategy</span>
                <li v-for="(item, index) in projects[5].BrandStrategy" :key="index">{{ item }}</li>
              </ul>
            </div>
            <CaseContact data-aos="fade-up" />
          </div>
        </div>
      </section>

      <!-- Other information -->
      <section class="section__project other">
        <div class="other__padding other__gray">
          <div class="container">
            <h3 data-aos="fade-up">
              <span class="other__gray--icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="29"
                  height="30"
                  viewBox="0 0 29 30"
                >
                  <image
                    width="29"
                    height="30"
                    xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAeCAYAAADQBxWhAAAEdElEQVRIiZ2Xe5CWcxTHP+/bLiXRuiVGLm0j9xjMYFzG3dC4RoRkhTapKJKE3JfYdWmIRLkMxmXImDHJZdeKP8wasbqIYcaOMRXJJcOuOfbz0+N93p3S+WffeZ7zO9/fOed7vufZQnNzM2VsInA8cC/wRv71RtkewGXAmooyp48DhgH7AD8DS4FlOa8NtyOBE4D9jTm3FPRoYDqwM/AdcCrQAUwGFv8PoAh+OHAEcDCwa+ZdaxY0AOs9MBX4FBgJnOH79QFXCnKUgJHhn8AHQBNwNvBlxE2gxwIN1r0OuMXnUdbuGeDrgCU5uE6focD1QDWwGpgFBGHe9ALnAC9GzAA9Ebjbkt4DXAscAGwLNAJjgQcELgLjga8zgD0EvAvYBvgVaAHGBWn0qQX+AhYETyLIjcDesvQanaLML0uqRcAo4D3gNN9tn8lwiDzYBHjIc1HeuUBfEzgIeDtdNjJ9BxgEDLSfnwHP6JR6+AVQAzwhuQr2O9pyn9leYUmDNFt5wc2A5fb7BaAtgsWcVlmyG2z06ZKoIHOz1t8MDgE+Avbz4pcAT2b8o6/3Ayf5bBVwaEqi6IMGydPfZu+bCVDQD299HvA5cCCwqRV4tuSCy+RCm+ej5CvSyxRshWWaBgywFFHuwfZygn4djsUAz14IPA+sLanIFoL2VVzqTY7U02Qp4wg2BXjJTHoBj+pzEXCnv4d7ud9LAKNdtwKXy4URVqa9HGjYSjPusMeov88B5wO3S5Lo4dOOQdZiZG5yRFot/cISnxxoFrggIwepRpdathDtOblTnWM0WVZ/CExSjXJWDhRLfYdzOEGJ/Mk+zc55ww7O+BjLOMdRLGvFcg+16NW3bpo2gz6W8+okyyR7GL4/yOzqnKfWVaY91MrQ0t/s08ycF/RRj8dY0nkCBnl6K4XfbAholPQsCdQNuLqLDHtLttEugYlqdYza1opMUQltyx4sLW+lWtqghI3tArAncJslXWpmjb5LY9KkZM6054WuQIc4yFWytRxLe7qVRqpQsWG+AvpZGZTTEa62U4BH7H0OdJiA0c8LnM32MoB1Albqu51rbaExcM6XKyAJ+GFgxwRaEKTeHdri4i0nbXXOaZBjhmIQ5T8TeB+Yn/FvV4OHW/qQ1AeB3brV1NQMdXn3Ua4GWt7mjMRV2cNaA4XmvurFBpv1VMelzv3c5NmVrsk9/cIsVjgO3ZWsJV5glMwe58FpsrTVXielSVp9lb5/uPZKx2uVrYnLrY3Au1vOx3UYrwxebJBE+1juV2YySFlM9/cU/77luCXr55I4zBU3K0C/B3bxE6PRLGqt/2gPtjiHC3Jchh9lc9FzkdGWvqt2T0cLX09iUTSrndz8x+i8OPPx9bECMT8Ht85Wq9UzXBBP2eubBZxn+/5RpwpBeynss83uZL9TF9mvd3MweVvj6sNYQbSw12Twf5Z49C2YF7MVe/IVWfuJipTt4frsF/sXezZGK/T4XJ//a9l/oGJe97LxIfIBGkTZGNvc7+hQqvgOXmfA3w0SJ2uhul+kAAAAAElFTkSuQmCC"
                  />
                </svg>
              </span>Sketch
            </h3>
            <video
              width="auto"
              playsinline
              loop
              muted
              autoplay
              title="Ruchoma grafika - szkice postaci."
              data-aos="fade-up"
            >
              <source
                src="https://ik.imagekit.io/intervi/video/3-szkice2_lN6XbYM8n.mp4"
                type="video/mp4"
              />Your browser does not support the video tag.
            </video>
            <h3 data-aos="fade-up">
              <span class="other__gray--icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <image
                    id="painter-palette"
                    width="32"
                    height="32"
                    xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEEUlEQVRYhb2Xa4gWZRTHfztuG0XsmuQWBdWypmWFlQZFVIqYmUGKRZJRpF0Msyy62NVu1JeKPkg3TJK0i11IKroZa1F9qTbT7GIX0WglK23tsmxUGyd/Y9PM7O68of3hZeZ95jznnDnPOf9zpq6trY2K2A04CRgNHAEcAAxyayfwNfAJ8BbwKrCxitr6wkoR+wNzgWlAo083A2uBz/wf663AccD5wJ/Aa8C9wMsFjRUd2BW4CbgSaADeBx5R4RcF6W1oBsYCZwCnAuOBt4GLgdUFaSAprGxDC/AOcB3wMTAGuBk4EJhq+POItQuBkcBCYAhwH3AM0A5cWtgBlOXA4Z5hvM084E7gIWB6RuZXYCKwwv+RFy8Cu2dkwokZOvQ4cBBwPzAL6OktAi0abwKmALerfLrGhgGTlF0QL+BvgWuTlFnhnrEe3SigzaO4orcjiDN/2jc/C3jO9TFe55h4y4BFJt2+/lpdW6bMnNzerebEfGBl1oFsEkbCHQXcmDEe2OT1SOBDYAAwAvjd8sP7ET77wzINfJc7ttm5iG/PgSi1z024USpJ0Wx9R6k9ARyszMOWXHoccd7vAZ+aqD8puylvFJggrzybRmCupXZ5zngagXEm4tnAb8CDyqaYbRTO07l2K6LMeOAy4HhgeaIn00yWSJ7BZmtE4w1rul3FexqJmUBXRmGXa43KjFTf6eqMCD5gNANPWjGTE+m1UZLZQyqdaVKG0aW+TeBHoLvwPv+gW5nABcBTwNFG9yJ1h43nLcVxiWWGDHcOMBS41cyO2u2wHHsjrTLUuWej+lolstB3LvA98CVwWGLGbpZeh6psodcOHRtsaKuiyXDH3m9yOlMbG6KEEyl0rYtrvM7yLVpkvG+BLTU40KnzE9VRp07MBzyuhsSWmp7bYmAVcJUKoqT2Bq6xw1VFj5XVrI4OdXwkYQX2CUfz59plTtxlf39dBltUg/EUjwKnRKmp627gRG002XNW1Xv+AzMbtxiBHYGX/OUxVRZ+ISKwPpMY/wcGSvc/AEsSm8Mg+/fORoN0vp858nOS6ekn72TjrdoaL+n93cLr7f9bJYj5hW21oTFDWLvIH8OB04AzXbsHuDrVWm9WLnFYGJ2JSC04wf4xvI89MRvekNefb8dr5O58R+wLQ+QObDKdGdmI7DqNrivTkbbjDdZ+DKHXyuNVMcOOOqG/EbwMWSKKBvQBcEtm7quCvZRZWcOe7cg60G3/jiHisRqcWO51XuFJjQ4EvnI+iHN8xqQZUNj1b8S88KYzxLDC035Q1uNX+4kVA+htwLuZmaEMPY5o9FMFpShzII3EscAdwKHO9OHIJSWMGTome7++oKkfVPk67uvjNNp4zBOHAK/8FzbdEZ/nvzj7Xe99dQB/AXPs+KUaMRr4AAAAAElFTkSuQmCC"
                  />
                </svg>
              </span>Colors
            </h3>
            <div class="other__gray--colorsbox">
              <div data-aos="zoom-in" data-aos-easing="ease-out-back">
                <span>#000000</span>
              </div>
              <div data-aos="zoom-in" data-aos-delay="300" data-aos-easing="ease-out-back">
                <span>#ffffff</span>
              </div>
              <div data-aos="zoom-in" data-aos-delay="600" data-aos-easing="ease-out-back">
                <span>#FFC400</span>
              </div>
              <div data-aos="zoom-in" data-aos-delay="900" data-aos-easing="ease-out-back">
                <span>#FF7600</span>
              </div>
              <div data-aos="zoom-in" data-aos-delay="1200" data-aos-easing="ease-out-back">
                <span>#00ACFF</span>
              </div>
              <div data-aos="zoom-in-left" data-aos-delay="1500" data-aos-easing="ease-out-back">
                <span>#94E900</span>
              </div>
            </div>
            <h3 data-aos="fade-up">
              <span class="other__gray--icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="25"
                  height="30"
                  viewBox="0 0 25 30"
                >
                  <image
                    id="text"
                    width="25"
                    height="30"
                    xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAABMklEQVQ4je3UTytEURjH8Y9JyUI2/iykKLGQrGQnKwsrKyvvwDvxCixslBcgK2Ux/mWJDVkIGyRC+VNopMMdnc7MGBrL+dXpPj2/c77nPvfc8zTk8/kZtKlNb5hvxCJOa4T1Yi/A3tFXYv9Nd8jlcFMjKOgElwH2EiXD99uPxmTkjeM5GhuR94BCLtkhlLuEKayjP/ECZAILifepFCYr+wz3Jc7XqW3jKIurwn6jQ+ym88JpXmVvUtTsL2DXGI7WFfAUYKMlU6vrIPu3/qXMsqrD6rAK+ldYYxQ3YSV7BvVgLvJf0Zk1wqKmsVYO1ozupIddRHFoTcdRNcsYrAQr7h5f+lihve9EiZIWlMJas8Z4i02MoCuZEy54B1p+gj1iNYOF8gJsDEPJmgG04xxb31l8ADuMPw8ItBh2AAAAAElFTkSuQmCC"
                  />
                </svg>
              </span>Typhography
            </h3>
            <h2 data-aos="fade-up">MONTSERRAT</h2>
            <p data-aos="fade-up">
              Montserrat is a font with distinct character that stands out on
              the colorful backgrounds of our packaging. This font is spartan,
              so it is much more acceptable. Its simplicity is perfectly
              balanced with the expressive style of the packaging and color
              scheme. This makes our project extremely modern.
            </p>
          </div>
        </div>

        <!-- Text -->
        <div class="position-relative">
          <div class="other__padding--janczaki">
            <div class="other__text row pb-0">
              <div class="col-xs-12 col-lg-6">
                <h2 data-aos="fade-up">
                  <span class="pl-xs-1 pl-sm-4">Janczak Family</span>
                </h2>
              </div>
              <div class="col-xs-12 col-lg-6">
                <h2 data-aos="fade-up" class="other__line"></h2>
              </div>
            </div>
            <div class="row other__text text-standard-margin" data-aos="fade-up">
              <p class="text-standard col-xs-12 col-md-6">
                The animated brand heroes make the message much more accessible.
                All the members of the family can become company ambassadors,
                and can, for example, act as company awards’ recipients in
                social media contests.
              </p>
              <p class="text-standard col-xs-12 col-md-6">
                The positive feelings evoked by the Janczak Family of products
                undoubtedly help define the product and the entire brand.
                However, the most important function is to remind the customer
                of the ads where the brand heroes appeared.
              </p>
            </div>
          </div>
        </div>

        <!-- Images -->
        <JanczakiProductComponent
          :name="janczakiProducts[0].name"
          :inscription="janczakiProducts[0].inscription"
          :video="janczakiProducts[0].video"
          :image1="janczakiProducts[0].image1"
          :image2="janczakiProducts[0].image2"
        />

        <!-- Text -->
        <div class="position-relative">
          <div class="other__padding--janczaki">
            <div class="other__text row pb-0">
              <div class="col-xs-12 col-lg-6">
                <h2 data-aos="fade-up">
                  <span class="pl-xs-1 pl-sm-4">Granny Buckwheat and Papa Rice</span>
                </h2>
              </div>
              <div class="col-xs-12 col-lg-6">
                <!-- <h2 data-aos="fade-up" class="other__line"></h2> -->
              </div>
            </div>
            <div class="row other__text text-standard-margin" data-aos="fade-up">
              <p class="text-standard col-xs-12 col-md-6">
                Tastes just like grandma's! She won’t ever leave us feeling
                hungry. Granny Buckwheat represents traditional Old-World hearty cuisine:
                delicious and easy to prepare meals with hulled oats. It also
                symbolizes organic and natural products, safe cultivation and
                good farming practices.
              </p>
              <p class="text-standard col-xs-12 col-md-6">
                Papa Rice is a symbol of the head of the brand family. He works
                from Monday to Friday, 9-5. As a young man, he moved to the big
                city, got married and started a family. He moves with the times,
                but also represents nostalgia for the flavors of childhood. He
                is a regular guy and loves down home cooking. He loves to sit
                down to a hearty dinner after work.
              </p>
            </div>
          </div>
        </div>

        <!-- Images -->
        <JanczakiProductComponent
          :name="janczakiProducts[1].name"
          :inscription="janczakiProducts[1].inscription"
          :video="janczakiProducts[1].video"
          :image1="janczakiProducts[1].image1"
          :image2="janczakiProducts[1].image2"
        />

        <!-- Text -->
        <div class="position-relative">
          <div class="other__padding--janczaki">
            <div class="other__text row pb-0">
              <div class="col-xs-12 col-lg-6">
                <h2 data-aos="fade-up">
                  <span class="pl-xs-1 pl-sm-4">Daughter Corn</span>
                </h2>
              </div>
              <div class="col-xs-12 col-lg-6">
                <h2 data-aos="fade-up" class="other__line"></h2>
              </div>
            </div>
            <div class="row other__text text-standard-margin" data-aos="fade-up">
              <p class="text-standard col-xs-12 col-md-6">
                Daughter Corn represents the younger generation, especially
                those who care about their appearance and health. She is
                associated with everything about the role hulled oats play in
                balanced meals and a healthy diet.
              </p>
              <p class="text-standard col-xs-12 col-md-6">
                She is also associated with using groats in modern cooking
                trends (vegetarian, vegan, gluten-free, etc.).
              </p>
            </div>
          </div>
        </div>

        <!-- Images -->
        <JanczakiProductComponent
          :name="janczakiProducts[2].name"
          :inscription="janczakiProducts[2].inscription"
          :video="janczakiProducts[2].video"
          :image1="janczakiProducts[2].image1"
          :image2="janczakiProducts[2].image2"
        />

        <!-- Text -->
        <div class="position-relative">
          <div class="other__padding--janczaki">
            <div class="other__text row pb-0">
              <div class="col-xs-12 col-lg-6">
                <h2 data-aos="fade-up">
                  <span class="pl-xs-1 pl-sm-4">Babyboy Millet</span>
                </h2>
              </div>
              <div class="col-xs-12 col-lg-6">
                <!-- <h2 data-aos="fade-up" class="other__line"></h2> -->
              </div>
            </div>
            <div class="row other__text text-standard-margin" data-aos="fade-up">
              <p class="text-standard col-xs-12 col-md-6">
                An old Polish adage says that "the healthy are raised on creamed-wheat millet”, which is undoubtedly true - it contains valuable
                minerals, vitamins and fiber. The youngest member of the family
                essentially shows us how hulled oats are important for our
                health, no matter your age.
              </p>
              <p class="text-standard col-xs-12 col-md-6">
                Babyboy Millet is the most relialble spokesman for this issue
                and evokes positive emotions.
              </p>
            </div>
          </div>
        </div>

        <!-- Images -->
        <JanczakiProductComponent
          :name="janczakiProducts[3].name"
          :inscription="janczakiProducts[3].inscription"
          :video="janczakiProducts[3].video"
          :image1="janczakiProducts[3].image1"
          :image2="janczakiProducts[3].image2"
        />
      </section>

      <!-- Navigation -->
      <section class="section__project nav">
        <div class="section-box">
          <div class="title__box w-100">
            <h2>
              <router-link to="/project-brilliant-mind" style="float: left;">Previous</router-link>
              <router-link to="/project-matthias" style="float: right;">Next project</router-link>
            </h2>
          </div>
          <FloatingSocials :hoverColor="projects[5].dot" />
          <FloatingText />
          <FloatingContact />
          <BackToTop />
        </div>
      </section>
    </div>
  </ScrollProgressBar>
</template>

<style lang="scss" scoped>
section {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>

<script>
import projects from "@/assets/projects";
import ComponentJanczaki from "@/components/inner-components/ComponentJanczaki";
import JanczakiProductComponent from "@/components/small-components/JanczakiProductComponent";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import Menu from "@/components/small-components/Menu";
import FloatingText from "@/components/small-components/FloatingText";
import CaseContact from "@/components/small-components/CaseContact";
import FloatingContact from "@/components/small-components/FloatingContact";
import BackToTop from "@/components/small-components/BackToTop";
import ScrollProgressBar from "@/components/small-components/ScrollProgressBar";
import mixColor from "@/js/functions";
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ProjectJanczaki",
  data() {
    return {
      projects: projects,
      activeSectionTitle: 0,
      isWhite: true,
      prevBg: "",
      isScrolling: false,
      activeSection: 0,
      activeSectionMenuColor: "",
      showChild: true,
      showTeam: false,
      sections: [
        {
          absoluteIndex: 0,
        },
      ],
      janczakiProducts: [
        {
          name: "kasza gryczana",
          inscription: "buckwheat",
          video:
            "https://ik.imagekit.io/intervi/video/9-gryczana_VUaR-NEBJ.mp4",
          image1: "https://ik.imagekit.io/intervi/10_T_GxTmYQW.jpg",
          image2: "https://ik.imagekit.io/intervi/11_wN9MH5_B5K.jpg",
        },
        {
          name: "ryż biały",
          inscription: "white rice",
          video: "https://ik.imagekit.io/intervi/video/13-ryz_HiMX-AKZA.mp4",
          image1: "https://ik.imagekit.io/intervi/14_AItecXaLD.jpg",
          image2: "https://ik.imagekit.io/intervi/15_XrRoeX62A.jpg",
        },
        {
          name: "kasza kukurydziana",
          inscription: "corn grits",
          video: "https://ik.imagekit.io/intervi/video/17-korn_gcMhqmIG_K.mp4",
          image1: "https://ik.imagekit.io/intervi/18_GJX_FJnVR.jpg",
          image2: "https://ik.imagekit.io/intervi/19_Jswb3miEBV.jpg",
        },
        {
          name: "kasza jaglana",
          inscription: "millet",
          video:
            "https://ik.imagekit.io/intervi/video/21-jaglana_M0DNJTWdz.mp4",
          image1: "https://ik.imagekit.io/intervi/22_PGxybRQA1.jpg",
          image2: "https://ik.imagekit.io/intervi/23_p8hPGmsRu.jpg",
        },
      ],
    };
  },
  mounted() {
    this.checkMenuActive();
  },
  watch: {
    isScrolling: function () {
      if (this.isScrolling == false) {
        window.onscroll = function () {};
      } else {
        window.onscroll = function () {
          window.scrollTo(0, 0);
        };
      }
    },
  },
  created() {
    setTimeout(function () {
      AOS.refresh();
    }, 1000);
    setTimeout(function () {
      mixColor();
    }, 1000);
  },
  methods: {
    checkMenuActive: function () {
      if (this.isScrolling == true) {
        window.onscroll = function () {
          window.scrollTo(0, 0);
        };
      } else {
        window.onscroll = function () {};
      }
    },
  },
  components: {
    ScrollProgressBar,
    ComponentJanczaki,
    JanczakiProductComponent,
    FloatingSocials,
    CaseContact,
    FloatingContact,
    FloatingText,
    BackToTop,
    Menu,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ProjectJanczaki.vue